import { render } from "./GoBack.vue?vue&type=template&id=144cd28f"
import script from "./GoBack.vue?vue&type=script&lang=ts"
export * from "./GoBack.vue?vue&type=script&lang=ts"
script.render = render

export default script